export default __webpack_public_path__ + "static/media/icon-img-4.2dde05e7.webp";